import { z } from 'zod';
/**
 * Politique de mot de passe appliquée à la création/changement de mot de passe.
 * Alignée sur les contraintes de sécurité du cahier des charges (§8 Sécurité).
 */
export const passwordSchema = z
    .string()
    .min(12, 'Le mot de passe doit contenir au moins 12 caractères')
    .max(128)
    .regex(/[a-z]/, 'Le mot de passe doit contenir au moins une minuscule')
    .regex(/[A-Z]/, 'Le mot de passe doit contenir au moins une majuscule')
    .regex(/[0-9]/, 'Le mot de passe doit contenir au moins un chiffre')
    .regex(/[^A-Za-z0-9]/, 'Le mot de passe doit contenir au moins un caractère spécial');
export const loginSchema = z.object({
    username: z.string().min(3).max(100),
    password: z.string().min(1).max(128),
});
export const totpVerifySchema = z.object({
    challengeToken: z.string().min(10),
    code: z
        .string()
        .length(6)
        .regex(/^\d{6}$/, 'Le code doit être composé de 6 chiffres'),
});
/** Changement de mot de passe (auto-service, y compris le changement obligatoire imposé au seed). */
export const changePasswordSchema = z.object({
    currentPassword: z.string().min(1).max(128),
    newPassword: passwordSchema,
});
/**
 * Provisionnement 2FA — demande de secret (`/auth/2fa/setup`). `challengeToken`
 * n'est fourni que lors du provisionnement forcé en cours de connexion (rôle
 * exigeant la 2FA, pas encore active) : dans ce cas, aucune session n'existe
 * encore et c'est ce jeton, pas l'en-tête Authorization, qui identifie
 * l'utilisateur. Omis lors d'une activation volontaire depuis un compte déjà
 * authentifié.
 */
export const twoFactorSetupRequestSchema = z.object({
    challengeToken: z.string().min(10).optional(),
});
/** Confirmation du code TOTP lors du provisionnement initial de la 2FA. */
export const twoFactorEnableSchema = z.object({
    code: z
        .string()
        .length(6)
        .regex(/^\d{6}$/, 'Le code doit être composé de 6 chiffres'),
    challengeToken: z.string().min(10).optional(),
});
//# sourceMappingURL=auth.js.map